'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _Defaults = require('conversations-schema/constants/Defaults');

var _TargetAudienceTypes = require('conversations-schema/constants/TargetAudienceTypes');

var _TargetAudienceTypes2 = _interopRequireDefault(_TargetAudienceTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  createdAt: null,
  id: _Defaults.DEFAULT_MESSAGE_ID,
  name: null,
  targetAudienceType: _TargetAudienceTypes2.default.ALL_VISITORS,
  askForEmail: false,
  askForEmailMessage: null,
  targetAudienceId: null,
  inclusionUrls: (0, _immutable.List)(),
  exclusionUrls: (0, _immutable.List)(),
  portalId: null,
  richTextSupported: false,
  initialMessage: null,
  customAwayMessage: null,
  creatorId: null,
  active: true,
  lastEditorId: null,
  lastEditedAt: null,
  userIds: (0, _immutable.List)(),
  teamIds: (0, _immutable.List)(),
  rotatingToOwner: null,
  fallbackUser: null,
  exclusionListIds: (0, _immutable.List)(),
  inclusionListIds: (0, _immutable.List)(),
  initialBotResponder: null
}, 'Message');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/Message.js
// module id = 100
// module chunks = 0 1